import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Typography,
} from "@mui/material";
import { PlusIcon } from "../../../@lib/icons/plus";
import { MinusIcon } from "../../../@lib/icons/minus";
import { useState } from "react";
import { Trans } from "react-i18next";

function FAQ({ translator }: any) {
  const [isExpanded, setIsExpanded] = useState({ status: false, index: null });

  const handleAccordionChange = (event: any, expanded: any, index: any) => {
    setIsExpanded({ status: expanded, index: index });
  };
  return (
    <Stack
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "white",
      }}
      pt={5}
      px={7}
    >
      <Typography variant="h5" color={"#00AAB0"}>
        {translator("landingPage.FAQ")}
      </Typography>
      <Typography variant="h3" mt={1}>
        {translator("landingPage.Frequently Asked Questions")}
      </Typography>
      <Typography
        variant="h6"
        color={"#494E54"}
        fontWeight={"500"}
        mt={1}
        mb={5}
      >
        {translator("landingPage.Have questions? Check out some answers here!")}
      </Typography>
      <Accordion
        expanded={isExpanded?.status && isExpanded?.index === 1}
        onChange={(event, expanded) =>
          handleAccordionChange(event, expanded, 1)
        }
        sx={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={
            <Box>
              {isExpanded?.status && isExpanded?.index === 1 ? (
                <MinusIcon />
              ) : (
                <PlusIcon />
              )}
            </Box>
          }
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography fontWeight={"700"}>
            {translator("landingPage.What is The Niyel Tracker?")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {translator(
              "landingPage.The Niyel Tracker is the first African tracking tool to support your advocacy and decision-making with precise, real-time data. It is your go-to resource for staying informed and adapting to the ever-evolving landscape of policies and practices across Africa."
            )}
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={isExpanded?.status && isExpanded?.index === 2}
        onChange={(event, expanded) =>
          handleAccordionChange(event, expanded, 2)
        }
        sx={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={
            <Box>
              {isExpanded?.status && isExpanded?.index === 2 ? (
                <MinusIcon />
              ) : (
                <PlusIcon />
              )}
            </Box>
          }
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography fontWeight={"700"}>
            {translator(
              "landingPage.What issue areas does the Niyel Tracker currently cover?"
            )}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {translator(
              "landingPage.The Niyel Tracker will initially focus on three key areas"
            )}
          </Typography>
          <ul>
            <li>
              <span style={{ fontWeight: "700" }}>
                {translator("landingPage.Sanitation")}
              </span>{" "}
              {translator("landingPage.in Senegal, Burkina Faso, and Uganda.")}
            </li>
            <li>
              <span style={{ fontWeight: "700" }}>
                {translator("landingPage.Health & Immunization")}
              </span>{" "}
              {translator("landingPage.in Nigeria and the DRC.")}
            </li>
            <li>
              <span style={{ fontWeight: "700" }}>
                {translator("landingPage.Data Governance and AI")}
              </span>{" "}
              {translator(
                "landingPage.in Benin, Burkina Faso, and Senegal. We plan to expand our coverage to include all SDGs and the entire continent."
              )}
            </li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={isExpanded?.status && isExpanded?.index === 3}
        onChange={(event, expanded) =>
          handleAccordionChange(event, expanded, 3)
        }
        sx={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={
            <Box>
              {isExpanded?.status && isExpanded?.index === 3 ? (
                <MinusIcon />
              ) : (
                <PlusIcon />
              )}
            </Box>
          }
          aria-controls="panel1-content"
          id="panel4-header"
        >
          <Typography fontWeight={"700"}>
            {translator(
              "landingPage.Who can benefit from using the Niyel Tracker?"
            )}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {translator("landingPage.Our platform is designed for")}
            <ul>
              <li>
                <span style={{ fontWeight: "700" }}>
                  {translator("landingPage.Civil Society Organizations (CSOs)")}
                </span>{" "}
                {translator(
                  "landingPage.To gain insights that strengthen their impact and strategies."
                )}
              </li>
              <li>
                <span style={{ fontWeight: "700" }}>
                  {translator("landingPage.Advocates and Activists")}
                </span>{" "}
                {translator(
                  "landingPage.To stay updated and effectively mobilize for change."
                )}
              </li>
              <li>
                <span style={{ fontWeight: "700" }}>
                  {translator("landingPage.Governments and Policymakers")}
                </span>{" "}
                {translator(
                  "landingPage.To collaborate more efficiently and maintain accountability."
                )}
              </li>
              <li>
                <span style={{ fontWeight: "700" }}>
                  {translator("landingPage.Foundations and Funders")}
                </span>{" "}
                {translator(
                  "landingPage.To make informed decisions about where to allocate resources."
                )}
              </li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={isExpanded?.status && isExpanded?.index === 4}
        onChange={(event, expanded) =>
          handleAccordionChange(event, expanded, 4)
        }
        sx={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={
            <Box>
              {isExpanded?.status && isExpanded?.index === 4 ? (
                <MinusIcon />
              ) : (
                <PlusIcon />
              )}
            </Box>
          }
          aria-controls="panel1-content"
          id="panel5-header"
        >
          <Typography fontWeight={"700"}>
            {" "}
            {translator(
              "landingPage.Can the Niyel Tracker help identify key decision-makers and influencers?"
            )}{" "}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {translator(
              "landingPage.Yes. The Tracker maps influential figures in each focus area, helping you understand who holds power, how it shifts, and the networks that shape decision-making processes."
            )}
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={isExpanded?.status && isExpanded?.index === 5}
        onChange={(event, expanded) =>
          handleAccordionChange(event, expanded, 5)
        }
        sx={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={
            <Box>
              {isExpanded?.status && isExpanded?.index === 5 ? (
                <MinusIcon />
              ) : (
                <PlusIcon />
              )}
            </Box>
          }
          aria-controls="panel1-content"
          id="panel6-header"
        >
          <Typography fontWeight={"700"}>
            {" "}
            {translator(
              "landingPage.Will the Niyel Tracker eventually cover more issues and countries?"
            )}{" "}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {translator(
              "landingPage.Absolutely. Our vision is to create an inclusive, continent-wide resource for sustainable change. We aim to expand our coverage to include all SDGs and offer a comprehensive overview of policies and practices across Africa."
            )}
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={isExpanded?.status && isExpanded?.index === 6}
        onChange={(event, expanded) =>
          handleAccordionChange(event, expanded, 6)
        }
        sx={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={
            <Box>
              {isExpanded?.status && isExpanded?.index === 6 ? (
                <MinusIcon />
              ) : (
                <PlusIcon />
              )}
            </Box>
          }
          aria-controls="panel1-content"
          id="panel3-header"
        >
          <Typography fontWeight={"700"}>
            {" "}
            {translator(
              "landingPage.How is the Niyel Tracker developed and kept up to date?"
            )}{" "}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <Trans i18nKey={"landingPage.fifthFAQDescription"} />
            {/* {translator(
              "landingPage.The Niyel Tracker is powered by a team of student interns who are the primary researchers, mining data and keeping our information current. This initiative is as much about building capacity as it is about gathering data: we provide training and introduce students to the workforce, preparing them for future careers. Additionally, we have partnered with an African AI firm to lead the development of the Tracker. We believe in leveraging local talent and ensuring all data is stored and used on the continent, reinforcing our commitment to African innovation."
            )} */}
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={isExpanded?.status && isExpanded?.index === 7}
        onChange={(event, expanded) =>
          handleAccordionChange(event, expanded, 7)
        }
        sx={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={
            <Box>
              {isExpanded?.status && isExpanded?.index === 7 ? (
                <MinusIcon />
              ) : (
                <PlusIcon />
              )}
            </Box>
          }
          aria-controls="panel1-content"
          id="panel7-header"
        >
          <Typography fontWeight={"700"}>
            {" "}
            {translator(
              "landingPage.How can I access and use the Niyel Tracker?"
            )}{" "}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {translator(
              "landingPage.The Niyel Tracker is accessible through our website. You can explore dashboards tailored to your interests and download reports as needed. We are also developing features to make the platform more interactive and userfriendly."
            )}
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={isExpanded?.status && isExpanded?.index === 8}
        onChange={(event, expanded) =>
          handleAccordionChange(event, expanded, 8)
        }
        sx={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={
            <Box>
              {isExpanded?.status && isExpanded?.index === 8 ? (
                <MinusIcon />
              ) : (
                <PlusIcon />
              )}
            </Box>
          }
          aria-controls="panel1-content"
          id="panel8-header"
        >
          <Typography fontWeight={"700"}>
            {" "}
            {translator("landingPage.Is the Niyel Tracker free to use?")}{" "}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {translator(
              "landingPage.Our core features are accessible to the public, but we may offer premium insights or detailed reports in the future. We believe in democratizing information to drive meaningful change."
            )}
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={isExpanded?.status && isExpanded?.index === 9}
        onChange={(event, expanded) =>
          handleAccordionChange(event, expanded, 9)
        }
        sx={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={
            <Box>
              {isExpanded?.status && isExpanded?.index === 9 ? (
                <MinusIcon />
              ) : (
                <PlusIcon />
              )}
            </Box>
          }
          aria-controls="panel9-content"
          id="panel9-header"
        >
          <Typography fontWeight={"700"}>
            {translator(
              "landingPage.How do I stay updated on new features or expanded coverage?"
            )}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {translator(
              "landingPage.Sign up for our newsletter or follow us on our social media platforms to receive updates on new features, additional issue areas, and expanded coverage."
            )}
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={isExpanded?.status && isExpanded?.index === 10}
        onChange={(event, expanded) =>
          handleAccordionChange(event, expanded, 10)
        }
        sx={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={
            <Box>
              {isExpanded?.status && isExpanded?.index === 10 ? (
                <MinusIcon />
              ) : (
                <PlusIcon />
              )}
            </Box>
          }
          aria-controls="panel1-content"
          id="panel10-header"
        >
          <Typography fontWeight={"700"}>
            {" "}
            {translator(
              "landingPage.How can I provide feedback or suggest improvements?"
            )}{" "}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {translator(
              "landingPage.We welcome your input! Use the feedback form on our website to share your thoughts, or email us directly at [contact email]. Your suggestions are valuable as we continue to develop and refine the Niyel Tracker."
            )}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
}

export { FAQ };
